module.exports = __webpack_public_path__ + "static/media/Illus-LoyaltyHarvest.aee73021.png";